import { makeAutoObservable } from "mobx";

/**
 * Хранилище состояния внешней системы, которая пытается авторизоваться.
 */
export class ExternalSystemAuthorizationHandlerStore {

    /**
         * Конструктор.
         */
    constructor() {
        makeAutoObservable(this);
    }

    private _redirectUri: string | null = null;

    private _urlSearchParams: URLSearchParams | null = null;

    /**
     * Ссылка для перенаправления.
     */
    public get redirectUri() 
    {
        if(!this._redirectUri)
        {
            this._redirectUri = localStorage.getItem("redirectUri");
        }

        return  this._redirectUri;
    }

    public set redirectUri(value: string | null) 
    {
        if(value)
        {
            localStorage.setItem('redirectUri', value);
        }

        this._redirectUri = value;
    }

    /**
     * Параметры ссылки для перенаправления.
     */
    public get redirectParams() {

        if(!this._urlSearchParams)
        {
            var uri = new URLSearchParams();
            uri.set("client_id", localStorage.getItem("client_id") ?? "");
            uri.set("state", localStorage.getItem("state") ?? "");
            uri.set("code_challenge", localStorage.getItem("code_challenge") ?? "");
            uri.set("nonce", localStorage.getItem("nonce") ?? "");

            this._urlSearchParams = uri;
        }

        return this._urlSearchParams;
    }

    public set redirectParams(value: URLSearchParams) {
        if(value)
        {
            this._urlSearchParams = value
            localStorage.setItem('client_id', value.get('client_id') ?? "");
            localStorage.setItem('state', value.get("state") ?? "");
            localStorage.setItem('code_challenge', value.get("code_challenge") ?? "");
            localStorage.setItem('nonce', value.get("nonce") ?? "");
        }
    }

    /**
     * Метод очистки состояния.
     */
    public clear() {
        // Очищаем localStorage от редиректа и параметров.
        localStorage.removeItem('redirectUri');
        localStorage.removeItem('client_id');
        localStorage.removeItem('state');
        localStorage.removeItem('nonce');
        localStorage.removeItem('code_challenge');

        this._urlSearchParams = null;
        this._redirectUri = null;
    }
}
